import React, { useCallback, useState, createContext, useContext } from 'react';
import { Dialog, DialogContent, IconButton, Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { QuoteForm } from './QuoteForm';
interface QuoteContextValue {
  openQuote: () => void;
  closeQuote: () => void;
}
const QuoteContext = createContext<QuoteContextValue | undefined>(undefined);
export function useQuote() {
  const ctx = useContext(QuoteContext);
  if (!ctx) {
    throw new Error('useQuote must be used within a QuoteProvider');
  }
  return ctx;
}
export function QuoteProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const openQuote = useCallback(() => setOpen(true), []);
  const closeQuote = useCallback(() => setOpen(false), []);
  return <QuoteContext.Provider value={{
    openQuote,
    closeQuote
  }} data-id="element-102">
      {children}

      <Dialog open={open} onClose={closeQuote} fullScreen={fullScreen} maxWidth="sm" fullWidth aria-labelledby="quote-dialog-title" PaperProps={{
      sx: {
        borderRadius: {
          xs: 0,
          sm: 3
        }
      }
    }} data-id="element-103">
        <Box sx={{
        bgcolor: 'primary.main',
        color: 'white',
        px: {
          xs: 3,
          md: 4
        },
        py: 3,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
      }} data-id="element-104">
          <Box data-id="element-105">
            <Typography variant="body2" color="secondary.main" fontWeight="bold" textTransform="uppercase" letterSpacing={1} data-id="element-106">
              Free Consultation
            </Typography>
            <Typography id="quote-dialog-title" variant="h5" fontWeight="bold" data-id="element-107">
              Request Your Free Quote
            </Typography>
          </Box>
          <IconButton onClick={closeQuote} aria-label="Close quote form" sx={{
          color: 'white',
          mt: -0.5,
          mr: -1
        }} data-id="element-108">
            <CloseIcon data-id="element-109" />
          </IconButton>
        </Box>

        <DialogContent sx={{
        px: {
          xs: 3,
          md: 4
        },
        py: 4
      }} data-id="element-110">
          <Typography variant="body2" color="text.secondary" sx={{
          mb: 3
        }} data-id="element-111">
            Tell us about your project — no commitment required, and we respect
            your privacy.
          </Typography>
          <QuoteForm hideHeading data-id="element-112" />
        </DialogContent>
      </Dialog>
    </QuoteContext.Provider>;
}